// frontend/src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import MapPage from './components/MapPage';

// Componentes PÚBLICOS
import Home from './components/Home';
import FichaDifunto from './components/FichaDifunto';
import SearchPage from './components/SearchPage'; 
import PerfilFuneraria from './components/PerfilFuneraria';

// 🏛 Contexto GLOBAL
import { AyuntamientoProvider, useAyuntamiento } from './context/AyuntamientoContext';

const BACKEND_URL = '';
const API_URL_ENTRADAS = '/api/v1/entradas/index.json';

// --------------------------------------------------
// 🌍 1. LÓGICA Y DISEÑO (Consumidor del Contexto)
// --------------------------------------------------
function AppContent() {
    // 💉 Ahora sí podemos usar configAyto porque estamos DENTRO del Provider
    const { configAyto, globalConfig } = useAyuntamiento();

    const [entradas, setEntradas] = useState([]); 
    const [selectedEntranceCoords, setSelectedEntranceCoords] = useState(null);

    // Usamos el slug de la URL para las rutas de los links
    const pathSegments = window.location.pathname.split('/');
    const currentSlug = pathSegments[1] || '';

    // 🚀 CARGA DE ENTRADAS (Corregida para modo estático)
useEffect(() => {
    if (currentSlug && currentSlug !== 'search' && currentSlug !== 'login') {
        // Quitamos el query string (?slug=...) para que lea el archivo físico
        axios.get(API_URL_ENTRADAS)
            .then(res => setEntradas(res.data || []))
            .catch(err => console.error("Error entradas:", err));
    }
}, [currentSlug]);

    const handleEntradaChange = (event) => {
        const id = event.target.value;
        if (!id) { setSelectedEntranceCoords(null); return; }
        const ent = entradas.find(e => e.id === parseInt(id));
        if (ent?.polilinea_coords) {
            const coords = typeof ent.polilinea_coords === 'string' ? JSON.parse(ent.polilinea_coords) : ent.polilinea_coords;
            setSelectedEntranceCoords(Array.isArray(coords[0]) ? coords[0] : coords);
        }
    };

    const openStreetView = () => {
        if (selectedEntranceCoords) {
            window.open(`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${selectedEntranceCoords[0]},${selectedEntranceCoords[1]}`, '_blank');
        }
    };

    // Determinamos si mostramos el header institucional
    const reservadas = ['admin', 'login', 'superadmin'];
    const showHeader = currentSlug && !reservadas.includes(currentSlug);

    return (
        <div className="App" style={{
            backgroundImage: globalConfig?.imagen_fondo_url ? `url(${BACKEND_URL}/${globalConfig.imagen_fondo_url})` : 'url(/cementerio-fondo.jpg.jpeg)',
            backgroundSize: 'cover', backgroundAttachment: 'fixed', minHeight: '100vh'
        }}>
            {showHeader && (
                <header className="App-header" style={{ backgroundColor: globalConfig?.color_principal || '#2d5a27' }}>
                    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '10px 20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <img 
                                    src={globalConfig?.id ? `${BACKEND_URL}/uploads/clientes/${globalConfig.id}/general/escudo.png` : '/images/escudo-defecto.png'} 
                                    alt="Escudo" style={{ height: '80px' }} 
                                />
                                <h1 style={{ fontSize: '1.8em', margin: 0 }}>
                                    <Link to={`/${currentSlug}`} style={{ color: 'white', textDecoration: 'none' }}>
                                        {/* 💉 LÓGICA SAAS: Nombre Contexto > Nombre URL */}
                                        Cementerio de {configAyto?.nombre || currentSlug.toUpperCase()}
                                    </Link>
                                </h1>
                            </div>
                            <nav>
                                <Link to={`/${currentSlug}`} style={{ color: 'white', marginLeft: '20px' }}>Inicio</Link>
                                <Link to={`/${currentSlug}/search`} style={{ color: 'white', marginLeft: '20px' }}>Búsqueda</Link>
                            </nav>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: '10px' }}>
                            <p style={{ margin: 0, fontWeight: 'bold', color: 'white' }}>
                                Guía digital de {configAyto?.nombre || currentSlug.toUpperCase()}
                            </p>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <select onChange={handleEntradaChange} style={{ padding: '5px', borderRadius: '15px' }}>
                                    <option value="">📍 Ver Accesos</option>
                                    {entradas.map(e => <option key={e.id} value={e.id}>{e.tramo_descripcion || `Acceso ${e.id}`}</option>)}
                                </select>
                                <button onClick={openStreetView} disabled={!selectedEntranceCoords} style={{ padding: '5px 15px', borderRadius: '15px', backgroundColor: 'white', color: '#2d5a27', border: 'none', fontWeight: 'bold' }}>IR A MAPA</button>
                            </div>
                        </div>
                    </div>
                </header>
            )}

            <main>
                <Routes>
                    <Route path="/:slug" element={<Home />} />
                    <Route path="/:slug/search" element={<SearchPage />} /> 
                    <Route path="/:slug/mapa" element={<MapPage />} /> 
                    <Route path="/:slug/funeraria/:funerariaSlug" element={<PerfilFuneraria />} />
                    <Route path="/:slug/difunto/:id" element={<FichaDifunto />} />
                    <Route path="/" element={<Navigate to="/tarazona" replace />} />
                </Routes>
            </main>
            {/* 🏷️ RESTAURADO: SELLO SaaS MEMORIAN 360 */}
            <div style={{
                position: 'fixed', bottom: '20px', right: '25px', zIndex: 9999,
                display: 'flex', alignItems: 'center', gap: '10px', opacity: 0.7,
                pointerEvents: 'none', userSelect: 'none', visibility: window.innerWidth <= 480 ? 'hidden' : 'visible'
            }}>
                <span style={{ fontSize: '11px', fontWeight: '800', letterSpacing: '1.2px', color: '#555', fontFamily: 'sans-serif', textShadow: '0 1px 2px rgba(255,255,255,0.8)' }}>
                    POWERED BY
                </span>
                <img 
                    src="/logo-memorian-360.png" 
                    alt="Memorian 360" 
                    style={{ height: '30px', width: 'auto' }} 
                    onError={(e) => { e.target.style.display = 'none'; }} 
                />
            </div>
            {/* 📱 BLOQUE DE INTELIGENCIA RESPONSIVA GLOBAL */}
<style>{`
    @media (max-width: 768px) {
        /* 1. Header en Vertical */
        .App-header > div > div { 
            flex-direction: column !important; 
            text-align: center;
            gap: 15px;
        }

        /* 2. Escudo centrado y Título más pequeño */
        .App-header h1 { 
            font-size: 1.3em !important; 
            line-height: 1.2;
        }

        .App-header img {
            height: 60px !important;
            margin: 0 auto;
        }

        /* 3. Menú de navegación centrado */
        nav {
            margin: 10px 0;
            display: flex;
            justify-content: center;
            width: 100%;
        }

        nav a { margin: 0 10px !important; }

        /* 4. Sub-barra de Accesos y Mapa */
        .App-header > div > div:last-child {
            flex-direction: column !important;
            gap: 10px;
        }

        /* 5. Botón Cerrar Sesión centrado */
        header button {
            width: 100%;
            margin-top: 10px;
        }
    }
`}</style>
        </div>
    );
}

// --------------------------------------------------
// 🌍 2. ROOT (El Envoltorio que provee el Contexto)
// --------------------------------------------------
export default function App() {
  return (
    <AyuntamientoProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AyuntamientoProvider>
  );
}